import qs from 'qs'
import { useIntl, FormattedMessage } from 'react-intl'

import CarouselViewAllLink from 'components/Common/CarouselViewAllLink'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'

import useOfferList from 'hooks/Offers/useOfferList'
import { getThemeClassName } from 'lib/theme/themeUtils'
import { CRUISE_BANK_OFFERS_FILTERS } from 'constants/cruise'

const filters: App.OfferListFilters = {
  cruiseLines: ['RCC'],
}

function CruisePageRoyalCruisesCarousel() {
  const intl = useIntl()
  const offerList = useOfferList({
    ...CRUISE_BANK_OFFERS_FILTERS,
    ...filters,
  })

  const viewAllLabel = intl.formatMessage({
    id: 'CksJZdN3_nd-qWOEiKBA',
    defaultMessage: 'View all',
    description: 'Button text to view all Royal Caribbean cruise offers from the hot sailings carousel',
  })

  if (!offerList.fetching && !offerList.offerIds.length) return null

  return <Group gap={32} direction="vertical">
    <LayoutContainer>
      <Group gap={16} direction="horizontal" horizontalAlign="space-between">
        <Heading variant="heading2">
          <FormattedMessage
            id="fDwsWshF63iaBqrlQmso"
            defaultMessage="Royal Caribbean Hot Sailings"
            description="Section heading for the Royal Caribbean only cruise offers carousel on the main cruises landing page"
          />
        </Heading>

        <CarouselViewAllLink
          to={`/search/cruises?${qs.stringify(filters, { arrayFormat: 'repeat' })}`}
        >
          {viewAllLabel}
        </CarouselViewAllLink>
      </Group>
    </LayoutContainer>

    <OfferListCarousel
      tileStyle="card-default"
      tileSize="medium"
      overrideOfferList={offerList}
      className={getThemeClassName({ desktop: 'default' })}
    />
  </Group>
}

export default CruisePageRoyalCruisesCarousel
